(function($, _) {
	var analyticsConfig = {
		consoleLog: false,
		trackAnonymous:false,
		analyticsUrl: '/outils/analytics.php',
		currentHost: 'https://'+document.domain,
		blockAllLink: false,
	};

	// window.bandeau_ENT.onload = function (pE_) {
		// pE = pE_;
		// console.log("bandeau_ENT is loaded");
	// };

	var analytics_event = {};

	var sendAction = function(action, what, description) {
		analytics_event.host=analyticsConfig.currentHost;

		if(pE) {
			if(pE.DATA.user != "guest") {
				analytics_event.authenticated=1;
			}
			else {
				analytics_event.authenticated=0;
			}
		}

		analytics_event.action=action;

		what = what.replace(new RegExp(/[àáâãäå]/g),"a");
		what = what.replace(new RegExp(/ç/g),"c");
		what = what.replace(new RegExp(/[èéêë]/g),"e");
		what = what.replace(new RegExp(/[É]/g),"E");
		what = what.replace(new RegExp(/[ìíîï]/g),"i");
		what = what.replace(new RegExp(/[òóôõö]/g),"o");
		what = what.replace(new RegExp(/[ùúûü]/g),"u");
		what = encodeURIComponent(what);
		analytics_event.what=what;

		description = description.replace(new RegExp(/[àáâãäå]/g),"a");
		description = description.replace(new RegExp(/ç/g),"c");
		description = description.replace(new RegExp(/[èéêë]/g),"e");
		description = description.replace(new RegExp(/[É]/g),"E");
		description = description.replace(new RegExp(/[ìíîï]/g),"i");
		description = description.replace(new RegExp(/[òóôõö]/g),"o");
		description = description.replace(new RegExp(/[ùúûü]/g),"u");
		description = encodeURIComponent(description);
		analytics_event.desc=description;

		var json_event = JSON.stringify(analytics_event);

		if(analyticsConfig.consoleLog) {
			console.log("TRACK-SEND : SEND : [url:"+analyticsConfig.analyticsUrl+"] [event:"+json_event+"]");
		}



		var posting = $.post(analyticsConfig.analyticsUrl, { event: json_event } );
		posting.done(function( data ) {
			if(analyticsConfig.consoleLog) {
				console.log("TRACK-SEND : IS SENT : [url:"+analyticsConfig.analyticsUrl+"] [event:"+json_event+"]");
			}
		});


	};

	var addServicesLinkHandlers = function() {
      $( "body" ).on( "click", "a", function() {
			var clickedLink = $(this);
			var linkHost = clickedLink.prop("hostname");

			if ( linkHost != "") {
				var fromAction = "";
				clickedLink.parents().each(function() {
					if(fromAction == '' && this.id == "nouveautes") {
						fromAction='nouveautes';
					}
					else if(fromAction == '' && this.id == "liste-service") {
						fromAction='home';
					}
					else if(fromAction == '' && this.id == "ENT_Menu") {
						fromAction='prol';
					}
					else if(fromAction == '' && this.id == "topApps") {
						fromAction='shortcut';
					}
					else if(fromAction == '' && this.id == "liste-tags") {
						fromAction='tab';
					}

					if(fromAction != '') {
						return false;
					}
				});

				// lien de login / logout
				if(linkHost == "auth.univ-lorraine.fr") {
					var linkPath = clickedLink.prop("pathname");
					if(linkPath == "/login") {
						sendAction('login-link-'+fromAction, clickedLink.prop("href"), "login");
					}
					else {
						sendAction('logout-link-'+fromAction, clickedLink.prop("href"), "logout");
					}
				}
				else {
					var descr = "";
					if(this.dataset.fname) {
						descr = this.dataset.fname;
					}
					else if (this.title) {
						descr = this.title;
					}
					else if (clickedLink.text()) {
						descr = clickedLink.text();
					}

					if( linkHost != document.domain) {
						if(fromAction == 'nouveautes') {
							sendAction('factuel-view', clickedLink.prop("href"), 'view news');
						}
						else {
							sendAction('out-link-'+fromAction, clickedLink.prop("href"), descr);
						}
					}
					else {
						if(fromAction == 'tab') {
							sendAction('tab-view-home', descr, descr);
						}
						else if(fromAction == 'nouveautes') {
							if(descr == 'Next') {
								sendAction('factuel-view', 'next', 'next');
							}
							else {
								sendAction('factuel-view', 'previous', 'previous');
							}
						}
						else {
							sendAction('portlet-view-'+fromAction, clickedLink.prop("href"), descr);
						}
					}
				}
			}
			if(analyticsConfig.blockAllLink) return false;
		});
	};

	var addFavHandlers = function() {
		$( "#liste-service" ).on( "click", ".card-fav", function() {
			var fname = this.dataset.fname;

			var currentElt = $(".card-fav[data-fname='"+fname+"']");
			if(currentElt[0]) {
				var favLevel = currentElt[0].dataset.level + 1;
				if(currentElt[0].dataset.level > 2) {
					sendAction('fav-change', fname, '0');
				}
				else {
					sendAction('fav-change', fname, currentElt[0].dataset.level);
				}
			}
		});
	};

	var addOpenMenuHandlers = function() {
		$('#open_ENT_button').on('click',function(){
			if($('#ENT_Menu').hasClass("pushmenu-open")) {
				sendAction('open-prol', 'open-menu', "");
			}
			else {
				sendAction('close-prol', 'close-menu', "");
			}
		});
	};

	var addCloseMenuHandlers = function() {
		$('#close_ENT_button').on('click',function(){
			sendAction('close-prol', 'close-menu', "");
		});
	};

	var addOpenMenuTabHandlers = function() {
		$('#ENT_Menu .links li').on('click',function(){
			if($(this).find("span").text() != "") {
				sendAction('tab-view-prol', $(this).find("span").text(), $(this).find("span").text());
			}
		});
	};

	var addGoUPbHandlers = function() {
		$('#lienGoUp').on('click',function(){
			sendAction('go-up', "go-up-home", "go-up");
		});
	};


	var timeoutGlobalSearch;
	var addGlobalSearchHandlers = function() {
		$('#search input').on('keyup',function(){
			if($('#search input').val().length >= 2) {
				//if you already have a timout, clear it
				if(timeoutGlobalSearch){
					clearTimeout(timeoutGlobalSearch);
				}
				//start new time, to perform ajax stuff in 500ms
				timeoutGlobalSearch = setTimeout(function() {
					sendAction('search', 'global-search-home', $('#search input').val());
				},500);
			}
		});
	};

	var addExtendSearchHandlers = function() {
		$('#btnRech').on('click',function(){
			sendAction('search', 'extend-search-home', $('#search input').val());
		});
	};

	var timeoutMenuSearch;
	var addMenuSearchHandlers = function() {
		$('.moteurRecherche .input-search').on('keyup',function(){
			if($('.moteurRecherche .input-search').val().length >= 2) {
				//if you already have a timout, clear it
				if(timeoutMenuSearch){
					clearTimeout(timeoutMenuSearch);
				}
				//start new time, to perform ajax stuff in 500ms
				timeoutMenuSearch = setTimeout(function() {
					sendAction('search', 'global-search-prol', $('.moteurRecherche .input-search').val());
				},500);
			}
		});
	};

	var addMenuExtendSearchHandlers = function() {
		$('.moteurRecherche .icon-Search').on('click',function(){
			sendAction('search', 'extend-search-prol', $('.moteurRecherche .input-search').val());
		});
	};




	$(document).ready(function(){
		if(analyticsConfig.consoleLog) console.log("TRACKING : ready to track action");

		addOpenMenuHandlers();
		addCloseMenuHandlers();
		addOpenMenuTabHandlers();

		addGoUPbHandlers();
		addFavHandlers();

		addServicesLinkHandlers();

		addMenuSearchHandlers();
		addMenuExtendSearchHandlers();

		addGlobalSearchHandlers();
		addExtendSearchHandlers();
	});
})(jQuery);
